import { useCallback, useState } from 'react';

export interface IUseOnValueChange {
  getSuggestions(value: string): void;
}

export const useGeoTagsSuggestValue = ({ getSuggestions }: IUseOnValueChange) => {
  const [suggestValue, setSuggestValue] = useState('');

  const onValueChange = useCallback(
    (value: string) => {
      setSuggestValue(value);
      getSuggestions(value);
    },
    [getSuggestions, setSuggestValue],
  );

  const clearSuggestValue = useCallback(() => {
    setSuggestValue('');
  }, [setSuggestValue]);

  return {
    clearSuggestValue,
    onValueChange,
    suggestValue,
  };
};
